import type { GridSortModel } from '@mui/x-data-grid';

export function sortModelsEqual(a: GridSortModel, b: GridSortModel): boolean {
  if (a.length !== b.length) return false;
  return a.every((item, index) => {
    const other = b[index];
    return item.field === other?.field && item.sort === other?.sort;
  });
}

/** When the grid clears sort on mount, keep the configured default until the user changes sort. */
export function resolveEffectiveSortModel(
  model: GridSortModel,
  defaultSortModel: GridSortModel,
): GridSortModel {
  if (model.length > 0) return model;
  if (defaultSortModel.length > 0) return defaultSortModel;
  return model;
}

export function buildGridFetchQueryKey(
  endpoint: string,
  params: Record<string, unknown>,
  page: number,
  filters: unknown,
  sortModel: GridSortModel,
): readonly unknown[] {
  return [
    'GET',
    endpoint,
    JSON.stringify(params),
    page,
    JSON.stringify(filters),
    JSON.stringify(sortModel),
  ] as const;
}
